import React from "react";
import Grid from "@material-ui/core/Grid";
import { colors } from "@material-ui/core";
import { getTotalAmount } from "../../../../utils/utils";
import tafqeet from "../../../../utils/tafqeet";
import "../riyals.css"

function TotalsInvCom(props) {

  const { found, sta, inv, locInv } = props;
  const styeNum = {
    fontWeight: "bold", textAlign: "center", color: colors.red[500], direction: "ltr",
    borderBottom: "solid 0.1px", borderColor: "#000"
  };
  const styeNumN = { fontWeight: "bold", direction: "ltr", textAlign: "Left", color: colors.red[500], };
  const styleSecond = { fontWeight: "bold", textAlign: "right", direction: "ltr", paddingRight: "0.5rem", borderBottom: "solid 0.1px", borderRight: "solid 0.1px" };
  const styleSecondEn = { fontWeight: "bold", textAlign: "Left", direction: "ltr", paddingLeft: "0.5rem", borderBottom: "solid 0.1px", borderRight: "solid 0.1px" };
  const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1rem", BorderBottom: "solid 1px" };

  const tot_all = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot));

  const tot_discount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.discount);

  const tot_vat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.amountOfVat);

  const tot_before = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot) - sta.tot?.discount);

  const tot_net = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.tot_net);

  const tot_before_Re = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot));
  const tot_net_Re = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.tot_net + sta.tot?.discount);

  return (
    <Grid item container
      justifyContent="center"
    >
      <Grid
        container
        item xs={12}
        style={{ fontWeight: "bold", border: "solid 1px", fontFamily: "Amiri-Regular", paddingTop: "0.9rem", marginLeft: "0cm", direction: "rtl" }}
      >
        <Grid container item xs={12} >
          <Grid container item xs={12} style={{ border: "solid 1px", backgroundColor: colors.grey[100] }} >
            <Grid container item xs={2} style={{ paddingRight: "2rem" }} > <div style={styeNumN}>{tot_net}  {" " + sta?.omlat[0]?.symbol ?? ""}</div></Grid>
            <Grid container item xs={1} > <div style={styleNameA}>{ }</div></Grid>
            {/* {["RS", "SAR", "SR"].includes(sta?.omlat[0]?.symbol) ?
              (<Grid container item xs={9} > <div style={styleNameA}>{tafqeet(sta.tot.tot_net, "SAR")}</div></Grid>) :
              (<Grid container item xs={9} > <div style={styleNameA}>{tafqeet(sta.tot.tot_net, "USD")}</div></Grid>)} */}
            {["RS", "SAR", "SR"].includes(sta?.omlat[0]?.symbol) ?
              <span style={{ fontFamily: "SaudiRiyal", fontSize: 20 }}>{"\u20C1"}</span>:
              <Grid container item xs={9} > <div style={styleNameA}>{tafqeet(sta.tot.tot_net, "USD")}</div></Grid>
            }
            <br />
          </Grid>
        </Grid>
        {sta?.tot?.re_disc ?
          <Grid container item xs={12}>
            <Grid item xs={2} >
              <div style={styeNum}>{tot_before_Re}{" " + sta?.omlat[0]?.symbol ?? ""}
              </div>
              <div style={styeNum}>{tot_vat} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{tot_net_Re} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{locInv?.desc_perc ?? 0} </div>{" "}
              <div style={styeNum}>{tot_discount} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{tot_net} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
            </Grid>
            <Grid item xs={5} >
              <div style={styleSecond}>{"الإجمالي قبل الضريبة"}</div>
              <div style={styleSecond}>{"("} {inv.tax}{"%"}{")"} {" مجموع ضريبة القيمة المضافة"}</div>{" "}
              <div style={styleSecond}>{"الإجمالي شامل الضريبة"}</div>
              <div style={styleSecond}>{"نسبة خصم ضمان الأعمال"}</div>
              <div style={styleSecond}>{"مبلغ خصم ضمان الأعمال"}</div>
              <div style={styleSecond}>{"الصافي المطلوب دفعه"}</div>
            </Grid>
            <Grid item xs={5} >
              <div style={styleSecondEn}>{"Total Excluding VAT"}</div>
              <div style={styleSecondEn}> {"VAT Total"}{"("} {inv.tax}{"%"}{")"} </div>
              <div style={styleSecondEn}>{"Total With VAT"}</div>
              <div style={styleSecondEn}>{"Retention %"}</div>
              <div style={styleSecondEn}>{"Retention Amount"}</div>
              <div style={styleSecondEn}>{"Net Amount Payable"}</div>
            </Grid>
          </Grid> :
          <Grid container item xs={12}>
            <Grid item xs={2} >
              <div style={styeNum}>{tot_all}{" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{tot_discount} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{tot_before} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
              <div style={styeNum}>{tot_vat} {" " + sta?.omlat[0]?.symbol ?? ""}</div>{" "}
              <div style={styeNum}>{tot_net} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
            </Grid>
            <Grid item xs={5} >
              <div style={styleSecond}>{"الاجمالي غير شامل القيمة المضافة"}</div>
              <div style={styleSecond}>{"الخصم"}</div>
              <div style={styleSecond}>{"الاجمالي الخاضع للضريبة"}</div>
              <div style={styleSecond}>{"("} {inv.tax}{"%"}{")"} {" مجموع ضريبة القيمة المضافة"}</div>{" "}
              <div style={styleSecond}>{"الاجمالي النهائي شامل الضريبة"}</div>
            </Grid>
            <Grid item xs={5} >
              <div style={styleSecondEn}>{"Total Excluding VAT"}</div>
              <div style={styleSecondEn}>{"Discount"}</div>
              <div style={styleSecondEn}>{"Total Taxable Amount"}</div>
              <div style={styleSecondEn}> {"VAT Total"}{"("} {inv.tax}{"%"}{")"} </div>
              <div style={styleSecondEn}>{"Total Amt With Tax"}</div>
            </Grid>
          </Grid>
        }

      </Grid>
      {(found.BillNotes != "...." && found.BillNotes != null && found.BillNotes != "")
        && (
          <Grid
            item
            container
            xs={12}
          >
            <Grid item xs={12}>
              <div style={{ direction: "ltr", fontWeight: "bold", textAlign: "right" }}> {"Desscription / "}{"البيان"}</div>
            </Grid>
            <Grid item xs={12}>
              <div style={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                fontWeight: "bold",
                direction: "rtl",
                fontFamily: "Amiri-Regular",
                textAlign: "right"
              }}>
                {inv.notes}
              </div>
            </Grid>
            {locInv?.salesmanName != "" && locInv?.salesmanName != null &&
              <Grid container item xs={12} style={{ direction: "rtl", fontWeight: "bold" }}>
                {"المندوب / "}{locInv?.salesmanName}
              </Grid>
            }
          </Grid>
        )}

    </Grid>
  );
}
export default TotalsInvCom;